export const EngagementSurveysRoutes = [
    {
        "url": "/guest-touchpoint/survey/:survey_id?user_engagement_point_id&hauth-token",
        "name": "appLayout.harriSH.guest-engagement-survey",
        "type": "frontend",
        "loginRequired": false,
        "component": "engagementSurvey",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["engagement-surveys", "communication_hub_shared"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/engagement-surveys/engagement-surveys.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/communication-hub/communication-hub.shared.downgrade.module");
                }
            },
            { type: "library", path: `${CDNUri || '../'}ext_libs/jwplayer/jwplayer.js` },
        ]
    },
    {
        "url": "/harri-engage/survey/:survey_id?user_engagement_point_id",
        "name": "appLayout.harriSH.engagement-survey",
        "type": "frontend",
        "loginRequired": true,
        "component": "engagementSurvey",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["engagement-surveys", "communication_hub_shared"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/engagement-surveys/engagement-surveys.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/communication-hub/communication-hub.shared.downgrade.module");
                }
            },
            { type: "library", path: `${CDNUri || '../'}ext_libs/jwplayer/jwplayer.js` },
        ]
    },
];
//# sourceMappingURL=engagement-surveys.routes.js.map